<template>
  <div
    class="filtersView"
    :class="{'filtersView--collapsed': isCollapsed}"
  >
    <div
      class="filtersView__head"
      @click="isCollapsedToggle"
    >
      <h2 class="filtersView__title">
        <slot name="title" />
      </h2>
      <BaseIcon
        class="filtersView__chevron"
        icon="chevron-down"
      />
    </div>
    <div class="filtersView__content">
      <slot name="content" />
    </div>
    <div class="filtersView__summary">
      <slot name="summary" />
    </div>
  </div>
</template>

<script setup>
const isCollapsed = ref(false);
function isCollapsedToggle () {
	isCollapsed.value = !isCollapsed.value;
}
</script>
